module.exports = __webpack_public_path__ + "static/images/components/Back/images/close-hover.b9d1585b.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/close-hover.png
// module id = 2492
// module chunks = 11